import { css } from "@emotion/react";

import { colors } from "@styles";

export const iconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin-left: 0.5rem;
  height: 100%;
  background-color: ${colors.backgroundWhite};
`;

export const toolTipText = css`
  color: ${colors.white};
`;
